/**
 * Introduction the recipient still has to attach after they sign in.
 *
 * The intro page writes pending_intro_token (the raw token, so a short
 * test token round-trips) and pending_intro_saved_at. A missing saved-at
 * is treated as fresh. A saved-at older than a day is dropped.
 */

export const PENDING_INTRO_TOKEN = 'pending_intro_token';
export const PENDING_INTRO_SAVED_AT = 'pending_intro_saved_at';

const TOKEN_RE = /^[A-Za-z0-9_-]{1,64}$/;
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

function store() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function stashPendingIntro(token) {
  const s = store();
  if (!s || !token || !TOKEN_RE.test(token)) return;
  s.setItem(PENDING_INTRO_TOKEN, token);
  s.setItem(PENDING_INTRO_SAVED_AT, String(Date.now()));
}

export function peekPendingIntro() {
  const s = store();
  if (!s) return null;
  const token = s.getItem(PENDING_INTRO_TOKEN);
  if (!token || !TOKEN_RE.test(token)) return null;
  const savedAtRaw = s.getItem(PENDING_INTRO_SAVED_AT);
  if (savedAtRaw) {
    const savedAt = Number(savedAtRaw);
    if (!savedAt || Date.now() - savedAt > MAX_AGE_MS) {
      s.removeItem(PENDING_INTRO_TOKEN);
      s.removeItem(PENDING_INTRO_SAVED_AT);
      return null;
    }
  }
  return token;
}

export function introContinuePath() {
  const token = peekPendingIntro();
  return token ? `/intro/${token}` : null;
}

export function consumePendingIntro(expected) {
  const token = peekPendingIntro();
  if (!token) return null;
  if (expected && token !== expected) return null;
  const s = store();
  if (s) {
    s.removeItem(PENDING_INTRO_TOKEN);
    s.removeItem(PENDING_INTRO_SAVED_AT);
  }
  return token;
}
